import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubscriptiondelete } from "../../../Pages/Exam/IExam";

export const DeleteSubscriptionSlice = createSlice({
  name: "DeleteSubscription",
  initialState: {} as IReduxState<ISubscriptiondelete>,
  reducers: {
    deleteSubscription: (state, _) => {
      state.isLoading = true;
    },
    successdeleteSubscription: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteSubscription: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteSubscriptionResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteSubscription,
  failuredeleteSubscription,
  successdeleteSubscription,
  clearDeleteSubscriptionResponse,
} = DeleteSubscriptionSlice.actions;

export default DeleteSubscriptionSlice.reducer;
